import Vue from 'vue';

export default {
  fetchJobs() {
    const root = 'https://api.lever.co/v0/postings/musicworldmedia?mode=json&group=team';
    return Vue.http.get(root)
      .then(response => Promise.resolve(response.body))
      .catch(error => Promise.reject(error));
  },
};
